import React from 'react';
import {Link} from 'react-router-dom';
import {JobCard} from './JobCard';
import type {JobCardListProps} from './types';

export const JobCardListStatic = ({
    title,
    tableOption,
    link,
    headerAction,
}: JobCardListProps) => {
    const {fields, data = [], options: buttonsConfig} = tableOption;

    return (
        <div className="job-card-list">
            <div className="job-card-list-header">
                <h2>{title}</h2>
                {headerAction}
            </div>

            {data.length ? (
                data.map((row) => (
                    <JobCard
                        key={row.id}
                        row={row}
                        fields={fields}
                        buttonsConfig={buttonsConfig}
                    />
                ))
            ) : (
                <p className="job-card-list-empty">
                    {tableOption.noRecordsText || 'No records.'}
                </p>
            )}

            {link ? (
                <Link className="job-card-list-more" to={link}>
                    See more
                </Link>
            ) : null}
        </div>
    );
};
